<template>
  <el-dialog
    title="Banka Entegrasyon"
    :visible="Modal"
    center
    width="50%">
    <a @click="$emit('Modal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-tabs>
      <el-tab-pane :lazy=true>
        <span slot="label"><img src="https://pos.mudu.pro/oi/banka/akbank.png" width="70"></span>
        <akbank></akbank>
      </el-tab-pane>
      <el-tab-pane :lazy=true>
        <span slot="label"><img src="https://pos.mudu.pro/oi/banka/albaraka.png" width="60"></span>
        <albaraka></albaraka>
      </el-tab-pane>
      <el-tab-pane :lazy=true>
        <span slot="label"><img src="https://pos.mudu.pro/oi/banka/isbank.png" width="70"></span>
        <isbank></isbank>
      </el-tab-pane>
      <el-tab-pane :lazy=true>
        <span slot="label"><img src="https://pos.mudu.pro/oi/banka/seker.png" width="70"></span>
        <seker></seker>
      </el-tab-pane>
      <el-tab-pane :lazy=true>
        <span slot="label"><img src="https://pos.mudu.pro/oi/banka/teb.png" width="70"></span>
        <teb></teb>
      </el-tab-pane>
      <el-tab-pane :lazy=true>
        <span slot="label"><img src="https://pos.mudu.pro/oi/banka/ziraat.png" width="70"></span>
        <ziraat></ziraat>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer"s>
      <div class="entegre">
        <a href="https://aidatim.com" target="_blank">
          <img src="https://cdn.mudu.pro/Design/logo.png">
        </a>
        <h5>İlk 3 Banka ücretsiz olarak sunulmaktadır.</h5>
      </div>
      <h6 class="float-right text-right" style="font-size: 12px"><small><b>İp Adresleri:</b></small> <br>185.83.144.66
        ve 185.83.144.97<br> <small>İkisinide eklemelisiniz.</small></h6>
      <div class="clearfix"></div>
    </div>
  </el-dialog>
</template>

<script>
  import Akbank from "./Bankalar/akbank";
  import Albaraka from "./Bankalar/albaraka";
  import Kuveyt from "./Bankalar/kuveyt";
  import Seker from "./Bankalar/seker";
  import Teb from "./Bankalar/teb";
  import isbank from "./Bankalar/isbank";
  import ziraat from "./Bankalar/ziraat";

  export default {
    components: {isbank, Teb, Seker, Kuveyt, Albaraka, Akbank, ziraat},
    props: ['Modal'],
    data() {
      return {
        Bankalar: [
          {Adi: "Akbank", disabled: false, Comp: "akbank"},
          {Adi: "Albaraka", disabled: false, Comp: "albaraka"},
          {Adi: "Kuveyt Türk", disabled: true, Comp: "kuveyt"},
          {Adi: "Şeker Bank", disabled: false, Comp: "seker"},
          {Adi: "TEB", disabled: false, Comp: "teb"},
          {Adi: "İş Bank", disabled: false, Comp: "isbank"},
        ]
      }
    }
  }
</script>

<style scoped>
  .entegre {
    display: inline-block;
    float: left;
    text-align: left;
  }

  .entegre h5 {
    font-size: 10px;
  }

  button {
    margin-top: 15px;
  }

  .entegre img {
    width: 100px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Entegrasyon/BankaEntegrasyon.vue